// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19soj","newExpiryDate":"styles_newExpiryDate__rwAtM","footer":"styles_footer__2zRv8"};